import * as request from '../api-request'

export const budgetingPreview = async (data = {}) => {
  return request.toBlob('POST', 'budgeting/preview', data)
}

export const exportExcel = async (data = {}) => {
  return request.toBlob('POST', 'budgeting/download_excel', data)
}

export const saveHistory = async (data) => {
  return request.toJSON('POST', 'budgeting/create_history', data)
}

export const deleteHistory = async (data, token) => {
  return request.toJSON('POST', 'budgeting/delete_history', data, token)
}

export const checkPermission = async (data, token) => {
  return request.toJSON('POST', 'budgeting/check_permission', data, token)
}

export const getHistory = async (data, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `budgeting/get_history?${queryString}`, data, token)
}

export const getLatest = async (data, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `budgeting/latest?${queryString}`, data, token)
}

export const calculateScriptElements = async (data, token) => {
  return request.toJSON('POST', 'budgeting/calculate_script_elements', data, token)
}

export const forecastBudgeting = async (data, token) => {
  return request.toJSON('POST', 'budgeting/forecast', data, token)
}

export const forecastBudgetingForDefinedLocations = async (data, token) => {
  return request.toJSON('POST', 'budgeting/forecast_location', data, token)
}

export const getTaxDetails = async (data, token) => {
  return request.toJSON('GET', 'budgeting/tax_details', data, token)
}

export const getBudgetingWorkflow = async (data, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `budgeting/workflow?${queryString}`, data, token)
}

export const createBudgetingWorkflow = async (data, token) => {
  return request.toJSON('POST', 'budgeting/workflow', data, token)
}

export const updateWorkflow = async (data, token) => {
  return request.toJSON('PUT', 'budgeting/workflow', data, token)
}

export const breakBudgetingEntity = async (data, token) => {
  return request.toJSON('POST', 'budgeting/break_entity_to_pieces', data, token)
}
